module.exports = __webpack_public_path__ + "static/Gardiner-caf3048f807fc914b923c69b5693d67a.png";